<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <el-col :span="12"> <h3>指数账户</h3> </el-col>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane name="indexAccount">
          <h4 slot="label">指数账户</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col
                  :span="3"
                  style="text-align: center;line-height: 30px; margin-top: 30px;"
                >
                  <el-button
                    type="primary"
                    class="button_blue_color"
                    @click="openMoveIn()"
                  >
                    转入
                  </el-button>
                </el-col>
                <el-col
                  :span="3"
                  style="text-align: center;line-height: 30px;margin-left:20px; margin-top: 30px;"
                >
                  <el-button
                    type="danger"
                    style="background-color: #D02E27;border:#D02E27;"
                    @click="openMoveOut()"
                  >
                    转出
                  </el-button>
                </el-col>
                <el-col
                  :span="3"
                  style="text-align: center;line-height: 30px;margin-left:20px; margin-top: 30px;"
                >
                  <el-button
                    type="danger"
                    style="background-color: #3F7A21;border:#3F7A21"
                    @click="goToIndexTrading"
                  >
                    指数交易
                    <i class="el-icon-share" style="margin-left:5px;"></i>
                  </el-button>
                </el-col>
              </el-row>
            </div>
            <div class="userContent">
              <el-row>
                <el-col :span="4" class="common_border">
                  <div class="balanceLeft content-flex">
                    <h3>可提余额</h3>
                    <p>
                      <span class="balance_color">{{ bond.toFixed(2) }}</span
                      >&nbsp;元
                    </p>
                  </div>
                </el-col>
                <el-col
                  :span="4"
                  class="common_border"
                  style="margin-left:20px;"
                >
                  <div class="balanceLeft content-flex ">
                    <h3>当前盈亏</h3>
                    <p>
                      <span class="balance_color">{{
                        profit_loss.toFixed(2)
                      }}</span
                      >&nbsp;元
                    </p>
                  </div>
                </el-col>
                <el-col
                  :span="4"
                  class="common_border"
                  style="margin-left:20px;"
                >
                  <div class="balanceLeft content-flex">
                    <h3>亏损警戒线</h3>
                    <p>
                      <span class="balance_color">{{ warning.toFixed(2) }}</span
                      >&nbsp;元
                    </p>
                  </div>
                </el-col>
                <el-col
                  :span="4"
                  class="common_border"
                  style="margin-left:20px;"
                >
                  <div class="balanceLeft content-flex">
                    <h3>预警线亏损比</h3>
                    <p>
                      <span class="balance_color">{{
                        warning_line_ratio
                      }}</span>
                    </p>
                  </div>
                </el-col>
                <el-col
                  :span="4"
                  class="common_border"
                  style="margin-left:20px;"
                >
                  <div class="balanceLeft content-flex">
                    <h3>亏损平仓线</h3>
                    <p>
                      <span class="balance_color">{{
                        closeLine.toFixed(2)
                      }}</span
                      >&nbsp;元
                    </p>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top:20px;">
                <el-col :span="4" class="common_border">
                  <div class="balanceLeft content-flex ">
                    <h3>平仓线亏损比</h3>
                    <p>
                      <span class="balance_color">{{ close_line_ratio }}</span
                      >
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="transferlog">
          <h4 slot="label">流水记录</h4>
          <el-card>
            <el-form :inline="true" size="mini">
              <el-form-item label="日期">
                <el-date-picker
                  v-model="indexAccountDetails.time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  class="button_blue_color"
                  @click="getFlowLog"
                  >检索</el-button
                >
              </el-form-item>
            </el-form>
            <el-table
              :data="indexAccountDetails.data"
              size="mini"
              stripe
              style="width: 100%"
            >
              <el-table-column
                width="200"
                prop="time"
                align="center"
                label="时间"
              ></el-table-column>
              <el-table-column
                width="200"
                prop="type"
                align="center"
                label="备注"
              ></el-table-column>
              <el-table-column
                width="200"
                prop="amount"
                align="center"
                label="金额"
              ></el-table-column>
              <el-table-column
                width="200"
                prop="balance"
                align="center"
                label="余额"
              ></el-table-column>
            </el-table>

            <div class="changePage" style="padding-top: 15px;">
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-left"
                @click="prevIndexAccountDetails"
                size="mini"
              >
                上一页
              </el-button>
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-right"
                @click="nextIndexAccountDetails"
                size="mini"
                style="float: right"
              >
                下一页
              </el-button>
            </div>
          </el-card>

          <div
            style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;"
          >
            只显示最近12个月记录
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- DIALOG: MoveIn -->
    <el-dialog
      class="movein_popup"
      title="转入至指数账户"
      :visible.sync="moveInState"
    >
      <el-form
        ref="form"
        size="small"
        label-position="left"
        class="custom-transfer-form"
        label-width="120px"
      >
        <el-form-item label="主账户余额">
          <!-- <h4 slot="label">账户余额:</h4> -->
          <p>{{ cash }} 元</p>
        </el-form-item>

        <el-form-item label="指数账户余额">
          <!-- <h4 slot="label">账户余额:</h4> -->
          <p>{{ indexAccountBalance }} 元</p>
        </el-form-item>
        <el-form-item label="金额">
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveInAmount"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer half-buttons">
        <el-button @click="moveInState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="movein"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- DIALOG: MoveOut -->
    <el-dialog
      class="movein_popup"
      title="转出至主账户"
      :visible.sync="moveOutState"
    >
      <el-form
        ref="form"
        size="small"
        label-position="left"
        class="custom-transfer-form"
        label-width="120px"
      >
        <el-form-item label="主账户余额">
          <!-- <h4 slot="label">账户余额:</h4> -->
          <p>{{ cash }} 元</p>
        </el-form-item>

        <el-form-item label="指数账户余额">
          <!-- <h4 slot="label">账户余额:</h4> -->
          <p>{{ indexAccountBalance }} 元</p>
        </el-form-item>
        <el-form-item label="金额">
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveOutAmount"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer half-buttons">
        <el-button @click="moveOutState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="moveout"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "indexAccount",
  data() {
    return {
      cash: 0,
      indexAccountBalance: 0,
      moveInAmount: 0,
      moveOutAmount: 0,
      moveInState: false,
      moveOutState: false,
      bond: 0,
      profit_loss: 0,
      warning: 0,
      warning_line_ratio: 0,
      closeLine: 0,
      close_line_ratio: 0,
      indexAccountDetails: {
        date: [],
        data: [],
        page: 1,
        num: 20
      },
      activeName: "indexAccount"
    };
  },
  methods: {
    goToIndexTrading() {
      this.$store.commit("setIsIndex", true);
      this.$router.push({
        path: "/stockdetailed",
        query: {
          symbol: "sh000001",
          isIndex: true,
          direction: 0
        }
      });
    },
    openMoveOut() {
      this.moveOutAmount = 0;
      this.moveOutState = true;
    },
    openMoveIn() {
      this.moveInAmount = 0;
      this.moveInState = true;
    },
    movein() {
      let that = this;
      let money = that.moveInAmount;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "index_account",
            token: sessionStorage.getItem("token"),
            action: "movein",
            amount: money
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.moveInState = false;
            that.$message({
              message: res.data.msg,
              type: "success",
              onClose: function() {
                // reload data
                that.mainMethod();
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    moveout() {
      let that = this;
      let money = that.moveOutAmount;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "index_account",
            token: sessionStorage.getItem("token"),
            action: "moveout",
            amount: money
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.moveOutState = false;
            that.$message({
              message: res.data.msg,
              type: "success",
              onClose: function() {
                // reload data
                that.mainMethod();
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    //获取用户信息
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.moveInAmount = that.cash;
            that.moveOutAmount = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getIndexAccountBalance() {
      const that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var d = res.data.data;
            that.indexAccountBalance =
              d.index_trade_account_withdrawable != null
                ? d.index_trade_account_withdrawable
                : "0.00";
            that.mainAccountBalance = d.cash != null ? d.cash : "0.00";
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg || "获取余额失败");
          }
        })
        .catch(() => {
          // Placeholder: use mock when API not ready
          that.indexAccountBalance = "0.00";
        });
    },
    getCurrentDetailedIndex() {
      const that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed_index",
            token: sessionStorage.getItem("token"),
            cid: "index"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            const info = res.data.data || {};
            that.bond = info.bond != null ? Number(info.bond) : 0;
            that.available =
              info.available != null ? Number(info.available) : 0;
            that.profit_loss =
              info.profit_loss != null ? Number(info.profit_loss) : 0;
            that.currentTotal = info.total != null ? Number(info.total) : 0;
            that.warning = info.warning != null ? Number(info.warning) : 0;
            that.closeLine = info.close != null ? Number(info.close) : 0;
            that.warning_line_ratio =
              info.warning_line_ratio != null ? info.warning_line_ratio : "0%";
            that.close_line_ratio =
              info.close_line_ratio != null ? info.close_line_ratio : "0%";
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg || "获取账户明细失败");
          }
          that.syncDashboardOverflow();
        })
        .catch(() => {});
    },
    getFlowLog() {
      let that = this;

      const requestData = {
        nozzle: "index_account",
        token: sessionStorage.getItem("token"),
        action: "querylog",
        page: that.indexAccountDetails.page,
        num: that.indexAccountDetails.num
      };

      if (
        that.indexAccountDetails.time &&
        that.indexAccountDetails.time.length === 2
      ) {
        requestData.start = that.indexAccountDetails.time[0];
        requestData.end = that.indexAccountDetails.time[1];
      }

      that
        .$http({
          url: "/",
          method: "post",
          data: requestData
        })
        .then(function(res) {
          if (res.data.code == 1) {
            let resData = res.data;
            that.indexAccountDetails.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    prevIndexAccountDetails() {
      let page = this.indexAccountDetails.page;
      if (page == 1) {
        this.$message({
          message: "已经是第一页",
          type: "warning"
        });
      } else {
        this.indexAccountDetails.page = page - 1;
        this.getFlowLog();
      }
    },
    nextIndexAccountDetails() {
      let page = this.indexAccountDetails.page;
      if (this.indexAccountDetails.data.length < this.indexAccountDetails.num) {
        this.$message({
          message: "已经是最后一页",
          type: "warning"
        });
      } else {
        this.indexAccountDetails.page = page + 1;
        this.getFlowLog();
      }
    },

    mainMethod() {
      this.getUserinfo();
      this.getIndexAccountBalance();
      this.getCurrentDetailedIndex();
      this.getFlowLog();
    }
  },
  mounted() {
    let activeTab = this.$route.query.active_tab;
    if (activeTab) {
      this.activeName = activeTab;
    }
    this.getUserinfo();
    this.getIndexAccountBalance();
    this.getCurrentDetailedIndex();
    this.getFlowLog();
  }
};
</script>

<style scoped>
.half-buttons {
  display: flex;
}

.half-buttons .el-button {
  width: 50%;
}

/deep/ .el-tabs__item.is-active {
  color: #0d268d !important;
}

/deep/ .el-tabs__item:hover {
  color: #0d268d !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #0d268d !important;
}

/deep/ .common_border1 {
  padding: 15px !important;
}
.userContent {
  /*height: 60px;*/
  text-align: left;
}
.balanceLeft {
  height: 60px;
  line-height: 1.5;
  text-align: left;
}
.balanceLeft h4 {
  font-weight: normal;
}
.balanceLeft p {
  color: #999;
}
.balance {
  font-size: 18px;
  color: #ff7100;
}
.balance_color {
  color: #ed7d31 !important;
  font-weight: normal !important;
}
</style>

<style>
.movein_popup .el-dialog {
  width: 25% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/indexAccount.vue